import { Box, Container, Typography } from "@material-ui/core";
import React from "react";

export default function ConcernTextArea({
  heading,
  subHeading,
  placeholder,
  concernText,
  setConcernText,
  concernTextError,
  setConcernTextError,
}) {
  function handleTextArea(e) {
    setConcernTextError(false);
    const text = e.target.value.trim();
    if (text.length > 500) {
      setConcernTextError(true);
    }
    setConcernText(text);
  }
  function handleTextAreaBlur(e) {
    var text = e.target.value.trim();
    var textArea: any = document.querySelector(".concern-text");
    if (textArea) {
      textArea.value = text;
    }
  }
  return (
    <Box className="section-50" component={"section"}>
      <Container className="container">
        <Typography component={"h2"} className="section-heading">
          {heading}
        </Typography>
        <Typography style={{ color: "var(--text-color-2)" }}>
          {subHeading}
        </Typography>
        <div className="text-box">
          <textarea
            name=""
            id=""
            cols={30}
            rows={7}
            className="input-field concern-text"
            placeholder={placeholder}
            onChange={(e) => handleTextArea(e)}
            onBlur={(e) => handleTextAreaBlur(e)}
          ></textarea>
          {concernTextError && (
            <Typography className="error-message">
              500文字以内で入力してください。
            </Typography>
          )}
        </div>
      </Container>
    </Box>
  );
}
